import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import LandingPage from './components/LandingPage';
import reportWebVitals from './metrics/reportWebVitals';
import { initHighlight } from './utils/highlight';

// Initialize MSW only in development or test environment if REACT_APP_MOCK_API is set
async function initializeMSW() {
  if (process.env.NODE_ENV === 'development' && process.env.REACT_APP_MOCK_API === 'true') {
    console.log('Starting Mock Service Worker...');
    const { worker } = await import('./mocks/browser');
    return worker.start({ onUnhandledRequest: 'bypass' });
  }
  return Promise.resolve();
}

// Initialize Highlight as early as possible (before rendering)
initHighlight();

// Initialize MSW before rendering the App
initializeMSW().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Router>
        <App />
        {/* <LandingPage /> */}
      </Router>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
